import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, typography, spacing, radius, sizing } from '@/styles/designTokens'

export const PanelRoot = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	height: '100%',
	minHeight: 0,
})

export const PanelHeader = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	padding: `${spacing.lg}px ${spacing.xl}px`,
	minHeight: 40,
	borderBottom: `1px solid ${colors.divider}`,
	flexShrink: 0,
})

export const PanelHeading = styled('h2')({
	margin: 0,
	fontSize: typography.fontSizeXl,
	fontWeight: typography.fontWeightSemiBold,
	lineHeight: typography.lineHeightXl,
	letterSpacing: typography.letterSpacingNormalLg,
	color: colors.textPrimary,
})

export const PanelHeadingCount = styled('span')({
	color: colors.textSecondary,
})

export const ItemList = styled(Box)({
	flex: '1 1 auto',
	minHeight: 0,
	overflowY: 'auto',
})

export const EmptyState = styled(Box)({
	flex: '1 1 auto',
	minHeight: 0,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: spacing.xs,
	padding: `${spacing.lg}px ${spacing.xl}px`,
})

export const EmptyStateText = styled('p')({
	margin: 0,
	fontSize: typography.fontSizeMd,
	fontWeight: typography.fontWeightRegular,
	lineHeight: typography.lineHeightMd,
	letterSpacing: typography.letterSpacingWide,
	color: colors.textPrimary,
	textAlign: 'center',
})

export const OrderSummaryFooter = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: spacing.sm,
	padding: `${spacing.md}px ${spacing.xl}px`,
	backgroundColor: colors.surfaceMuted,
	borderTop: `1px solid ${colors.border}`,
	flexShrink: 0,
})

export const ChevronWrap = styled(Box)({
	width: sizing.navIcon,
	height: sizing.navIcon,
	borderRadius: radius.circle,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
	color: colors.textSecondary,
})

export const SummaryTextRow = styled(Box)({
	flex: '1 1 auto',
	minWidth: 0,
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: spacing.sm,
})

export const FooterLabel = styled('span')({
	fontSize: typography.fontSizeLg,
	fontWeight: typography.fontWeightBold,
	lineHeight: typography.lineHeightLg,
	letterSpacing: typography.letterSpacingWide,
	color: colors.textPrimary,
	flex: '1 1 auto',
	minWidth: 0,
})

export const FooterTotal = styled('span')({
	fontSize: typography.fontSizeLg,
	fontWeight: typography.fontWeightBold,
	lineHeight: typography.lineHeightLg,
	letterSpacing: typography.letterSpacingWide,
	color: colors.textPrimary,
	flexShrink: 0,
	fontVariantNumeric: 'tabular-nums',
})
